import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Order} from "../../models/types";
import {orderStateParse} from "../../models/validate-order";
import {dateParse} from "../../hooks/formats";
import {StatusBadge} from "../commons/status-badge";

interface Props {
    item: Order;
    onClick?: () => void
}

export const OrderCard = (props: Props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    function handleClick(): void {
        if (!!props.onClick) {
            props.onClick();
        } else {
            navigate(`/orders/${props.item.id}`);
        }
    }

    return (
        <div className="flex items-start max-w-md py-4 px-8 bg-white shadow-md rounded-lg my-10 mx-5">
            <div className="flex items-start flex-col" onClick={handleClick}>
                <div>
                    {t('id')}: {props.item.id}
                </div>
                <h2 className="text-gray-800 text-3xl font-semibold my-3">
                    {t('partner')} {props.item.partnerName}
                </h2>
                <div>
                    {t('from')} {props.item.supplierName}
                </div>
                <div className="my-1">
                    {t('delivery_date')} {dateParse(props.item.deliveryDate)}
                </div>
                <div className="my-1">
                    {t('distribution_date')} {dateParse(props.item.distributionDate)}
                </div>
                <div className="flex p-2 items-center">
                    <div>{t("state")}</div>
                    <div className="ml-5 mr-auto">
                        <StatusBadge status={props.item.pendingDiscardRequest ? "DISCARD_REQUESTED" : props.item.state} />
                    </div>
                </div>
            </div>
        </div>
    );
};
